module.exports = __webpack_public_path__ + "img/imageedit_4_7918630074.d29cba63.png";